export enum AfterSaleProductTypeEnum {
	PERSONAL_CREDIT = "PERSONAL_CREDIT",
	EMPRESTIMO_PESSOAL = "EMPRESTIMO_PESSOAL",
	FINANCIAMENTO_DEVICES = "FINANCIAMENTO_DEVICES"
}

export enum RoutesEnum {
	EMPRESTIMO_CUPOM = "/emprestimo-cupom",
	EMPRESTIMO_LOGIN = "/emprestimo-login",
}

export enum EAuthType {
	OTP = "OTP",
	PASSWORD = "PASSWORD",
	CPF = "CPF"
}

